import en from './en';
import ru from './ru';

const allLocales = {
    en,
    ru,
} as const;

export default allLocales;